var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpload = function SvgUpload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0016 0.416672C20.9681 0.416672 21.7516 1.20017 21.7516 2.16667V20.8333C21.7516 21.7998 20.9681 22.5833 20.0016 22.5833C19.0351 22.5833 18.2516 21.7998 18.2516 20.8333V2.16667C18.2516 1.20017 19.0351 0.416672 20.0016 0.416672Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7641 0.929235C19.4475 0.245817 20.5556 0.245817 21.239 0.929235L28.239 7.92923C28.9224 8.61265 28.9224 9.72069 28.239 10.4041C27.5556 11.0875 26.4475 11.0875 25.7641 10.4041L20.0016 4.64155L14.239 10.4041C13.5556 11.0875 12.4475 11.0875 11.7641 10.4041C11.0807 9.72069 11.0807 8.61265 11.7641 7.92923L18.7641 0.929235Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50156 19.0833C3.46805 19.0833 4.25156 19.8668 4.25156 20.8333V23.1667C4.25156 23.9402 4.55885 24.6821 5.10583 25.2291C5.65281 25.776 6.39468 26.0833 7.16822 26.0833H32.8349C33.6084 26.0833 34.3503 25.776 34.8973 25.2291C35.4443 24.6821 35.7516 23.9402 35.7516 23.1667V20.8333C35.7516 19.8668 36.5351 19.0833 37.5016 19.0833C38.4681 19.0833 39.2516 19.8668 39.2516 20.8333V23.1667C39.2516 24.8685 38.5755 26.5006 37.3722 27.7039C36.1688 28.9073 34.5367 29.5833 32.8349 29.5833H7.16822C5.46642 29.5833 3.83431 28.9073 2.63095 27.7039C1.4276 26.5006 0.751556 24.8685 0.751556 23.1667V20.8333C0.751556 19.8668 1.53506 19.0833 2.50156 19.0833Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "upload.751f63591c1d47de3ceada46b59b6e63.svg";